<template>
    <div class="main-div">
        <header-add-contact @closeDialog="closeDialog" />
        <main-add-contact @closeDialog="closeDialog" :modalData="modalData" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderAddContact from './HeaderAddContact.vue';
import MainAddContact from './MainAddContact.vue';

const dialogRef = getDialogRef(ModalNames.ADD_CONTACT);
const closeDialog = () => {
    dialogRef.value.close();
};

// Get modal data if provided
const modalData = computed(() => dialogRef.value?.data || {});
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-md sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>
